import React from "react";
import PermResidance from "./PermRes";
import TempVisa from "./tempRes";

const Services = () => {
    return (
        <div>
            <PermResidance />
            <TempVisa />
        </div>

    )
}

export default Services;
